module.exports = __webpack_public_path__ + "static/img/agent4.766d6699.png";